<p-dialog
  [style]="{ width: '80vw' }"
  id="orderAddDialog"
  [(visible)]="isVisible"
  appendTo="body"
  (visibleChange)="dialogVisibleChange($event)"
  [modal]="true"
  [resizable]="false"
  [draggable]="false">
  <p-header class="page-title" style="font-size: 30px">
  </p-header>
  <h1>{{ 'ForwarderDesc.IncoTermsTable.Header' | translate }}</h1>
  <div>
    <table class="rtable ml-6">
      <thead>
        <tr>
          <th style="width:300px">{{ 'ForwarderDesc.IncoTermsTable.Rule.Title' | translate }}</th>
          <th style="width:150px">{{ 'ForwarderDesc.IncoTermsTable.Term' | translate }}</th>
          <th style="width:600px">{{ 'ForwarderDesc.IncoTermsTable.Content' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th [attr.rowspan]="this.anyForwarderCount" >{{ 'ForwarderDesc.IncoTermsTable.Rule.Any' | translate }}</th>
          <th scope="row">{{ this.firstAnyForwarder?.optionCode }}</th>
          <td>{{ this.firstAnyForwarder?.optionDesc }}</td>
        </tr>
        <tr *ngFor="let body of this.anyForwarderList">
          <th scope="row">{{ body?.optionCode }}</th>
        <td>{{ body?.optionDesc }}</td>
        </tr>
        <tr>
          <th [attr.rowspan]="this.shipForwarderCount">{{ 'ForwarderDesc.IncoTermsTable.Rule.Ship' | translate }}</th>
          <th scope="row">{{ this.firstShipForwarder?.optionCode }}</th>
          <td>{{ this.firstShipForwarder?.optionDesc }}</td>
        </tr>
        <tr *ngFor="let body of this.shipForwarderList">
          <th scope="row">{{ body?.optionCode }}</th>
        <td>{{ body?.optionDesc }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <h1>{{ 'ForwarderDesc.IncoTermsCost.Header' | translate }}</h1>
  <div>
  <p-table [value]="dataList" class="edittable mt-2 Incoterms">
      <ng-template pTemplate="header">
        <tr>
          <th rowspan="2" style="width:75px">{{ 'ForwarderDesc.IncoTermsCost.TermTitle' | translate }}</th>
          <th colspan="11" style="width:390px">{{ 'ForwarderDesc.IncoTermsCost.Header' | translate }}</th>
        </tr>
        <tr>
          <th *ngFor="let headerColumn of this.headerList"> {{ headerColumn }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dataList>
        <tr>
          <td *ngFor="let field of this.dataTableList"
          [ngClass]="defiendColor(dataList[field])"
          > {{ dataList[field] | translate }} </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>
